import React, { useEffect } from "react";

import getContentById from "../../../../shared/utils/getContentById";
import _ from "lodash";
import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, {
  animationCleanUp,
} from "../../../../../animations/worldcup/goalshots";

import assets from "./assets";
import getOptaCountryCode from "../../../../shared/utils/getOptaCountryCode";
import countries from "../../../../../language/de/countries.json";
import { useTranslation } from "react-i18next";
import {
  getTeamGoalmouth,
  getTeamStats,
} from "../../../../shared/utils/opta/statsHandler";
import Image from "../../../../shared/components/Image";
import {
  getDynamicLogoPath,
  toIsoDateString,
} from "../../../../shared/utils/functions";
import { WcBgCircle } from "../../../../shared/backgrounds/WcBgCircle/Index";
import ProgressBar from "../../../../shared/components/ProgressBar";
// import outroVideo9x16 from "../../../assets/outros/outro_playoffs_9x16.webm";

require("./style/style.scss");
require("./style/animation.scss");

const translations = {
  Group: "Gruppe",
};

export const translatePosition = ({
  leftPercent,
  topPercent,
  maxRight,
  maxLeft,
  maxHigh,
}) => {
  // Calculate the range for left and top positions
  const leftRange = maxLeft - maxRight;
  const topRange = maxHigh;

  // Scale the percentage values to fit within the restricted area
  const scaledLeft = ((leftPercent - maxRight) / leftRange) * 100;
  const scaledTop = ((maxHigh - topPercent) / topRange) * 100;

  // Mirror the scaled left position to switch sides (from right to left)
  // const mirroredLeft = 100 - scaledLeft;

  // Return the scaled left and top positions as an object
  return {
    left: scaledLeft,
    top: scaledTop,
  };
};

function convertGoalCoords(targetY, targetZ) {
  return {
    leftPercent: 50 + (targetY / 3.66) * 5.8,
    topPercent: (targetZ / 2.44) * 42,
  };
}

const Index = (props) => {
  const refs = {
    player: React.createRef(),
    team: React.createRef(),
  };

  const {
    animation,
    data,
    images: Images,
    apiSetup,
    mode,
    format,
    isTimeline,
  } = props;

  const id = `${_.get(data, "template_name", "")}_${_.get(data, "uuid", "")}`;
  const { t } = useTranslation();

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };

  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          refs,
          data,
          animation,
          mode,
          id,
          format,
          apiSetup,
          templateName: data?.template_name
        });
      }
    }

    //handle outro video BEGIN
    // if(mode === "video" && !isTimeline) {
    //   const outroVideo = $(`#${id} video.outro-optional-video`);
    //   outroVideo.get(0).addEventListener("loadedmetadata", function() {
    //       const that = this;
    //       setTimeout(()=> {
    //         outroVideo?.css('opacity', 1);
    //         this.currentTime = 0;
    //         that.play();
    //       }, frontendCfg.showOutroAfter)
    //     }, false);
    // }
    //handle outro video END

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const templateData = _.get(data, "data");

  const { options, fields, dynamic } = templateData;
  const matchInfo = _.get(dynamic, "matchInfo");
  const goalShots = _.get(dynamic, "goalShots");

  const competitionId = matchInfo?.competition?.id;

  const backgroundImage = getMainBackground(format, _.get(dynamic, "teamSide"));

  const homeTeam = matchInfo?.TeamStatistic?.[0];
  const awayTeam = matchInfo?.TeamStatistic?.[1];

  const teamSide = getContentById("selectedSide", fields);
  const teamId = teamSide === 'home' ? homeTeam?.TeamId : awayTeam?.TeamId;

  const teamShots = _.filter(goalShots, (o) => {
    return o?.TeamId === teamId;
  });
  const goals = teamShots?.filter((g) => g.ShotResult === 'SuccessfulShot');

  const saved = teamShots?.length - goals?.length;
  let savedPercentage = 0;
  if (teamShots?.length > 0 && saved >0) {
    savedPercentage = (saved / teamShots?.length) * 100;
  }

  return (
    <div
      id={id}
      className={`T_${_.get(data, "template_name", "")} ${animation ? "animation" : ""
        } side-${_.get(dynamic, "teamSide")}`}
    >
      <TemplateBlock>
        <Backgrounds bg1={backgroundImage} loop={true} />

        <div className={"wc-content wc-content-v2"}>
          <ProgressBar height={"8px"} strokeColor="#177C76" />
          <div className={"wc-bg-content"}></div>

          <div className={"wc-headline green-glow"}>
            {t("Shots on goal", { keyPrefix: "templates" })}
          </div>

          <div className={"versus-info"}>
            <div className={"group"}>
              {matchInfo?.series?.name.replace(
                "Group",
                t("Group", { keyPrefix: "templates" }),
              ) || ""}
            </div>
          </div>

          <div className={"team-logo-container"}>
            {/*<Image className="team-logo" src={`/images/countries/svg/${teamAlpha2}.svg`} />*/}
            <Image
              className="team-logo"
              src={getDynamicLogoPath({
                team: teamSide === "home" ? homeTeam : awayTeam,
                competitionId,
              })}
            />
            <div className={"team-name home"}>
              {teamSide === "home"
                ? t(homeTeam?.TeamName, { ns: "countries" })
                : t(awayTeam?.TeamName, { ns: "countries" })}
            </div>
          </div>

          <div className={"dynamic-content"}>
            <div className={"goalmouth-content"}>
              <img src={assets.goalmouth} />
              <div className={"layer-shots"}>
                {_.map(teamShots, (shot, shotIndex) => {
                  const isOwnGoal = shot?.isOwnGoal;
                  const typeToColor = {
                    SuccessfulShot: "goal",
                    SavedShot: "saved",
                    ShotWide: "post",
                  };

                  let targetColorType = typeToColor[shot?.ShotResult];


                  const goalCoordsParams = {
                    maxHigh: 42.0,
                    maxRight: 44.2,
                    maxLeft: 55.8,
                  }; //included BARS


                  const {
                    leftPercent,
                    topPercent,
                  } = convertGoalCoords(
                    shot?.TargetPositionY,
                    shot?.TargetPositionZ
                  );

                  const translations = translatePosition({
                    leftPercent,
                    topPercent,
                    ...goalCoordsParams,
                  });

                  return (
                    <div
                      key={"shot-" + shot.EventId}
                      data-y={translations.top}
                      data-z={translations.left}
                      data-goalposition={shot?.goalPositionLabel}
                      className={`shot color-${targetColorType} ${isOwnGoal ? "own-goal" : ""
                        }`}
                      data-event={shot?.entryTypeLabel}
                      data-player={shot?.playerName}
                      data-time={`${shot?.timeMin}:${shot?.timeSec}`}
                      style={{
                        left: `calc(${translations.left}% - 15px)`,
                        top: `calc(${translations.top}%)`,
                      }}
                    >
                    </div>
                  );
                })}
              </div>
            </div>

            <div className={"field-content"}>
              <img src={assets.goalmouth_field} />
              <div className={"layer-positions"}>
                {_.map(teamShots, (shot, shotIndex) => {
                  const isOwnGoal = shot?.isOwnGoal;
                  const typeToColor = {
                    SuccessfulShot: "goal",
                    SavedShot: "saved",
                    ShotWide: "post",
                  };

                  let targetColorType = typeToColor[shot?.ShotResult];
                  let PositionY = teamSide === 'home' ? shot.PositionY : 68 - shot.PositionY;
                  let PositionX = teamSide === 'home' ? shot.PositionX : 105 - shot.PositionX;
                  const leftPercent = (PositionY / 68) * 100;

                  const topPercent = isOwnGoal
                    ? (PositionX / 105) * 100
                    : 100 - ((PositionX / 105) * 100);

                  return (
                    <div
                      key={"position-" + shot.EventId}
                      data-y={leftPercent}
                      data-x={topPercent}
                      data-goalposition={shot?.goalPositionLabel}
                      className={`shot color-${targetColorType} ${isOwnGoal ? "own-goal" : ""
                        }`}
                      data-event={shot?.entryTypeLabel}
                      data-player={shot?.playerName}
                      data-time={`${shot?.timeMin}:${shot?.timeSec}`}
                      style={{
                        left: `calc(${leftPercent}%)`,
                        top: `${topPercent * 2.609}%`,
                      }}
                    >
                      {/*{shotIndex+1}*/}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        <div className={"stats-block"}>
          <React.Fragment key={"stats2"}>
            {/* <div className={`stat-row color-`}>
              <div className={"stat-label"}>
                {t('Total Shots', { keyPrefix: "stats" })}
              </div>
              <div className={"stat-value"}>
                {goalShots?.length}
                <span>
                </span>
              </div>
            </div>

            <div className={"stat-separator"}></div> */}

            <div className={`stat-row color-`}>
              <div className={"stat-label"}>
                {t('Shots On Target ( inc goals )', { keyPrefix: "stats" })}
              </div>
              <div className={"stat-value"}>
                {teamShots?.length}
                <span>
                </span>
              </div>
            </div>

            <div className={"stat-separator"}></div>

            <div className={`stat-row color-`}>
              <div className={"stat-label"}>
                {t('Goals', { keyPrefix: "stats" })}
              </div>
              <div className={"stat-value"}>
                {goals?.length}
                <span>
                  {/* <span className={"sign"}>%</span> */}
                </span>
              </div>
            </div>

            <div className={"stat-separator"}></div>

            <div className={`stat-row color-`}>
              <div className={"stat-label"}>
                {t('calcParaden', { keyPrefix: "stats" })}
              </div>
              <div className={"stat-value"}>
                {saved}
                <span>
                  {parseFloat(savedPercentage).toFixed(1)}
                  <span className={"sign"}>%</span>
                </span>
              </div>
            </div>

          </React.Fragment>
        </div>
      </TemplateBlock>
    </div>
  );
};

const getMainBackground = (format, side) => {
  return _.get(assets, `sd_background_1920`);
};

export default Index;
